module.exports = __webpack_public_path__ + "img/contract_2.f51934ee.svg";